module.exports = __webpack_public_path__ + "img/company_ttang.bfee173b.png";